import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus } from "@fortawesome/free-solid-svg-icons";
import { TEMPERATURES } from "../utils/Constants";

export default function MealsToAdd({ meals, updateMeals }) {

  const removeMeal = (meal_key) => {

    const filteredMeals = meals.filter((meal, key) => (key !== meal_key));
    updateMeals(filteredMeals);
  };

  return (
    <>
      <h4>Meals to add:</h4>
      <table className="table table-striped table-bordered">
        <thead>
          <tr>
            <th style={{ width: 40 }}>Qty</th>
            <th>Meal</th>
            <th>Comments</th>
            <th style={{ width: 30 }}></th>
          </tr>
        </thead>
        <tbody>
          {meals.map((meal, i) => {
            let meal_temperature = (meal.temperature === 0 ? "" : "(" + TEMPERATURES[meal.temperature] + ")");
            return (
              <tr key={i}>
                <td className="text-center">{meal.qty}</td>
                <td>{meal.name} {meal_temperature}</td>
                <td>{meal.comments}</td>
                <td>
                  <button className="btn btn-sm btn-danger btn-block" onClick={() => removeMeal(i)}>
                    <FontAwesomeIcon icon={faMinus} />
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}
